import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: ${props => props.theme?.fonts?.secondary || 'sans-serif'};
    line-height: 1.6;
    color: ${props => props.theme?.colors?.secondary || '#000'};
    background-color: ${props => props.theme?.colors?.white || '#fff'};
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme?.fonts?.primary || 'serif'};
    font-weight: 500;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul {
    list-style: none;
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
    font-family: inherit;
  }

  input, textarea, select {
    font-family: inherit;
    outline: none;
  }

  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;

    @media (max-width: ${props => props.theme?.breakpoints?.tablet || '768px'}) {
      padding: 0 20px;
    }
  }

  /* KALENDARZ */

.react-datepicker {
  border: none;
  font-family: inherit;
  box-shadow: 0 8px 20px rgba(0,0,0,0.08);
  border-radius: 12px;
  overflow: hidden;
}

.react-datepicker__header {
  background: #f8f8f8;
  border-bottom: 1px solid #eee;
}

.react-datepicker__current-month {
  font-weight: 600;
  font-size: 1rem;
}

.react-datepicker__day-name {
  color: #999;
}

.react-datepicker__day {
  border-radius: 8px;
  transition: all 0.2s;
}

.react-datepicker__day:hover {
  background: #eee;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-range {
  background: #2f6fad;
  color: white;
}

.react-datepicker__day--keyboard-selected {
  background: #2f6fad;
}

.react-datepicker__navigation {
  top: 12px;
}
`;

